import React, { Component } from 'react';
import { connect } from 'react-redux';

import Menu from 'controls/menu/Menu';

import Wrapper from 'components/supervision/wrapper/Wrapper';

class Supervision extends Component {
  render() {
    return (
      <div>
        <Menu />
        <Wrapper
          recorderId={ this.props.recorderId }
          paramsSource={ this.props.paramsSource }
          recorderTemplateId={ this.props.recorderTemplateId }
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    recorderId: ownProps.match.params.recorderId || null,
    paramsSource: ownProps.match.params.paramsSource || 'template',
    recorderTemplateId: ownProps.match.params.recorderTemplateId || null
  };
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Supervision);
